import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  "class": "d-flex media-object position-relative"
};
var _hoisted_2 = {
  "class": "flex-shrink-0 d-none d-md-block"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  "class": "flex-grow-1 ms-md-3 min-w-0"
};
var _hoisted_5 = {
  "class": "message-input position-relative"
};
var _hoisted_6 = {
  "class": "rounded-3 p-3 text-content d-flex flex-column position-relative"
};
var _hoisted_7 = {
  "class": "textarea-content pe-4"
};
var _hoisted_8 = ["maxlength", "placeholder"];
var _hoisted_9 = {
  "class": "mt-auto"
};
var _hoisted_10 = {
  "class": "d-flex justify-content-between align-items-center"
};
var _hoisted_11 = {
  "class": "d-flex align-items-center"
};
var _hoisted_12 = {
  "class": "font-size-10 opacity-80 me-2"
};
var _hoisted_13 = {
  key: 1,
  "class": "border-top border-gray-blueish py-2 px-3 bg-white position-relative",
  id: "InquireReply"
};
var _hoisted_14 = {
  "class": "d-flex media-object align-items-center position-relative my-2"
};
var _hoisted_15 = {
  "class": "flex-shrink-0 d-none d-md-block"
};
var _hoisted_16 = ["src"];
var _hoisted_17 = {
  "class": "flex-grow-1 ms-md-3"
};
var _hoisted_18 = {
  "class": "d-grid"
};
import { ref, watch, defineAsyncComponent } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@dashboardApp/stores/UserStore';
import useMemberMeta from '@dashboardApp/composables/useMemberMeta';
import { useInboxStore } from '@dashboardApp/stores/InboxStore';
import { tooltipAction } from '@dashboardApp/helpers/tooltip';
import useComposeMessage from '@dashboardApp/composables/useComposeMessage';
import MessageTemplates from '@dashboardApp/components/inbox/MessageTemplates.vue';
import Signature from '@dashboardApp/components/inbox/Signature.vue';
import AppTextCounter from '@dashboardApp/components/AppTextCounter.vue';
export default {
  __name: 'Compose',
  props: {
    from: {
      type: Object,
      "default": {}
    },
    showForm: {
      type: Boolean,
      "default": false
    },
    isMobile: {
      type: Boolean,
      "default": false
    }
  },
  setup: function setup(__props) {
    var AppTooltip = defineAsyncComponent(function () {
      return import( /* webpackChunkName: "app-tooltip" */'@dashboardApp/components/AppTooltip.vue');
    });
    var props = __props;
    var localShowForm = ref(props.showForm);
    var _useComposeMessage = useComposeMessage(),
      content = _useComposeMessage.content,
      subject = _useComposeMessage.subject,
      signature = _useComposeMessage.signature,
      selectedContent = _useComposeMessage.selectedContent,
      showSendButton = _useComposeMessage.showSendButton,
      validateTemplate = _useComposeMessage.validateTemplate,
      template = _useComposeMessage.template,
      send = _useComposeMessage.send,
      saveSignature = _useComposeMessage.saveSignature;
    var _tooltipAction = tooltipAction(),
      toggle = _tooltipAction.toggle;
    var _useMemberMeta = useMemberMeta(),
      saveMeta = _useMemberMeta.saveMeta,
      getMeta = _useMemberMeta.getMeta;
    var userStore = useUserStore();
    var inboxStore = useInboxStore();
    var contactSupplierTooltipEl = ref(null);
    var router = useRouter();
    var route = useRoute();
    function templateDropdownOpened() {
      if (contactSupplierTooltipEl.value) {
        contactSupplierTooltipEl.value.gotIt();
      }
    }
    function sendMessage() {
      var _send;
      (_send = send(props.from.privateMsgUsername, props.from.name, props.from.subject, {
        template: template.value
      })) === null || _send === void 0 || _send.then(function (data) {
        localShowForm.value = false;
        showSendButton.value = true;
        moveThreadFromArchive(data);
      });
    }

    /**
     * Move thread from archive to messages
     * 
     * @param {Object} data The response data 
     */
    function moveThreadFromArchive(data) {
      // Move only if replied from the inbox archive view
      if (route.name !== 'inbox-archive-view') {
        return;
      }
      setTimeout(function () {
        if (data.archived) {
          return;
        }
        // Add as first element in messages.value 
        if (inboxStore.messages.findIndex(function (message) {
          return message._jv.id === inboxStore.threadId;
        }) === -1) {
          inboxStore.messages.unshift(Object.assign(data, {
            _jv: {
              id: inboxStore.threadId
            }
          }));
        }

        // Remove from archivedMessages.value
        inboxStore.archivedMessages.splice(inboxStore.archivedMessages.findIndex(function (message) {
          return message._jv.id === inboxStore.threadId;
        }), 1);
      }, 2000);
      router.push({
        name: 'inbox-view',
        params: {
          id: inboxStore.threadId
        }
      });
    }
    watch(function () {
      return props.showForm;
    }, function (val) {
      return localShowForm.value = val;
    });
    watch(function () {
      return localShowForm.value;
    }, function (val) {
      showSendButton.value = !val;
      if (!userStore.user.isSupplier && !getMeta('directory_onboarding_contact_supplier')) {
        toggle('directory_onboarding_contact_supplier');
      }
    }, {
      immediate: true
    });
    return function (_ctx, _cache) {
      var _props$from$supplier, _unref$appData$direct, _unref$appData$direct2;
      return _openBlock(), _createElementBlock(_Fragment, null, [localShowForm.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(["messages py-3 border-top border-gray-blueish bg-white position-relative", {
          'mb-3': !__props.isMobile,
          'px-4': __props.isMobile
        }]),
        id: "InquireReplyForm"
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        src: _unref(userStore).user.avatar,
        "class": "avatar rounded-circle",
        width: "75",
        height: "75"
      }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_props$from$supplier = __props.from.supplier) !== null && _props$from$supplier !== void 0 && _props$from$supplier.id ? (_openBlock(), _createBlock(MessageTemplates, {
        key: 0,
        content: _unref(content),
        "onUpdate:content": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(content) ? content.value = $event : null;
        }),
        subject: _unref(subject),
        "onUpdate:subject": _cache[1] || (_cache[1] = function ($event) {
          return _isRef(subject) ? subject.value = $event : null;
        }),
        validateTemplate: _unref(validateTemplate),
        "onUpdate:validateTemplate": _cache[2] || (_cache[2] = function ($event) {
          return _isRef(validateTemplate) ? validateTemplate.value = $event : null;
        }),
        template: _unref(template),
        "onUpdate:template": _cache[3] || (_cache[3] = function ($event) {
          return _isRef(template) ? template.value = $event : null;
        }),
        selectedContent: _unref(selectedContent),
        "onUpdate:selectedContent": _cache[4] || (_cache[4] = function ($event) {
          return _isRef(selectedContent) ? selectedContent.value = $event : null;
        }),
        "contact-name": __props.from.name,
        types: __props.from.supplier.types,
        isMobile: __props.isMobile,
        onDropdownShown: templateDropdownOpened
      }, null, 8, ["content", "subject", "validateTemplate", "template", "selectedContent", "contact-name", "types", "isMobile"])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return _isRef(content) ? content.value = $event : null;
        }),
        onFocus: templateDropdownOpened,
        maxlength: (_unref$appData$direct = _unref(userStore).appData.directory.inbox) === null || _unref$appData$direct === void 0 ? void 0 : _unref$appData$direct.contentLimit,
        "class": "textarea-input font-size-12 scrollbox overflow-auto w-100 border-0",
        id: "textarea-input",
        placeholder: "Hey, ".concat(_unref(userStore).user.fullname, ", I look forward to hearing from you! Before you send your first message, please take a look at these tips:\n\u2022  Have a full read at my overview details and supplier information.\n\u2022  Make sure to include all the details so we can give you the best response.\n\u2022  For your first contact you can use a message templates using the \u2018+\u2019 button.")
      }, null, 40, _hoisted_8), [[_vModelText, _unref(content)]]), _createVNode(Signature, {
        onOnUpdate: _unref(saveSignature),
        modelValue: _unref(signature),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return _isRef(signature) ? signature.value = $event : null;
        }),
        signatureDefault: _unref(inboxStore).signatureDefault
      }, null, 8, ["onOnUpdate", "modelValue", "signatureDefault"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[9] || (_cache[9] = _createElementVNode("a", {
        style: {
          "visibility": "hidden"
        },
        "class": "hover-opacity",
        "data-bs-toggle": "collapse",
        href: "#browse-files",
        role: "button",
        "aria-expanded": "false",
        "aria-controls": ""
      }, [_createElementVNode("img", {
        src: "/img/v5/db-ic_attachment.svg"
      })], -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, [_createVNode(AppTextCounter, {
        modelValue: _unref(content),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
          return _isRef(content) ? content.value = $event : null;
        }),
        maxlength: (_unref$appData$direct2 = _unref(userStore).appData.directory.inbox) === null || _unref$appData$direct2 === void 0 ? void 0 : _unref$appData$direct2.contentLimit
      }, null, 8, ["modelValue", "maxlength"])]), _createElementVNode("button", {
        onClick: sendMessage,
        type: "button",
        "class": "btn btn-primary btn-sm font-size-14 py-1 px-3",
        id: "btnInquire"
      }, "Send")])])])])])]), !_unref(userStore).user.isSupplier ? (_openBlock(), _createBlock(_unref(AppTooltip), {
        key: 0,
        metaKey: "directory_onboarding_contact_supplier",
        ref_key: "contactSupplierTooltipEl",
        ref: contactSupplierTooltipEl,
        step: "directory_onboarding_contact_supplier",
        style: {
          "right": "34px",
          "top": "22px",
          "width": "256px"
        },
        pulsePosition: "end",
        displayOnLoad: ""
      }, {
        message: _withCtx(function () {
          return _cache[10] || (_cache[10] = [_createTextVNode(" To email this supplier, either type your own message OR choose one of our handy message templates. Click on the '+' icon to browse available templates. ")]);
        }),
        _: 1
      }, 512)) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true), _unref(showSendButton) ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
        src: _unref(userStore).user.avatar,
        "class": "avatar rounded-circle",
        width: "75",
        height: "75"
      }, null, 8, _hoisted_16)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = function ($event) {
          localShowForm.value = true;
          showSendButton.value = false;
        }),
        "class": "btn font-size-12 sh-color-gray-2 text-start font-weight-regular px-0 border-0",
        role: "button",
        id: "btnReply"
      }, "Send a message....")])])])])) : _createCommentVNode("", true), !_unref(userStore).user.isSupplier ? (_openBlock(), _createBlock(_unref(AppTooltip), {
        key: 2,
        metaKey: "directory_onboarding_contact_supplier",
        ref_key: "contactSupplierTooltipEl",
        ref: contactSupplierTooltipEl,
        step: "directory_onboarding_contact_supplier",
        style: {
          "z-index": "2006"
        },
        variant: "mobile"
      }, {
        message: _withCtx(function () {
          return _cache[11] || (_cache[11] = [_createTextVNode(" To email this supplier, either type your own message OR choose one of our handy message templates. Click on the '+' icon to browse available templates. ")]);
        }),
        _: 1
      }, 512)) : _createCommentVNode("", true)], 64);
    };
  }
};